import React from 'react';
import CasinoContainer from '../../../../../components/casino/CasinoContainer';
import CasinoAuthContent from './CasinoAuthContent';

export default function CasinoAuth() {
  return (
    <CasinoContainer title={'Registration and authorization'}>
      <CasinoAuthContent />
    </CasinoContainer>
  );
}
